module.exports = __webpack_public_path__ + "static/media/BHARTIARTL.59ae3b25.txt";